package com.example.monetix.utils

import kotlin.math.*
import androidx.compose.runtime.Composable

// Struttura dati per le coordinate
data class GpsLocation(
    val latitude: Double,
    val longitude: Double
)

// Questa classe "expect" ci permette di chiamare il GPS dal codice condiviso.
// L'implementazione reale (actual) la scriveremo in androidMain e iosMain.
expect class LocationTracker {
    suspend fun getCurrentLocation(): GpsLocation?
}

// 🚀 FORMULA DI HAVERSINE (Matematica pura per calcolare la distanza in metri tra due punti GPS)
fun calculateDistanceInMeters(loc1: GpsLocation, loc2: GpsLocation): Double {
    val earthRadius = 6371000.0 // Raggio della terra in metri

    val dLat = (loc2.latitude - loc1.latitude) * (PI / 180.0)
    val dLon = (loc2.longitude - loc1.longitude) * (PI / 180.0)

    val a = sin(dLat / 2) * sin(dLat / 2) +
            cos(loc1.latitude * (PI / 180.0)) * cos(loc2.latitude * (PI / 180.0)) *
            sin(dLon / 2) * sin(dLon / 2)

    val c = 2 * atan2(sqrt(a), sqrt(1 - a))
    return earthRadius * c
}
@Composable
expect fun rememberLocationTracker(): LocationTracker